import { useEffect, useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import CloseIcon from "@mui/icons-material/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined"; // Acromegaly React components
import MDBox from "components/MDBox";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Swal from "sweetalert2";
import LoadingOverlay from "react-loading-overlay";
// Acromegaly React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { styled } from "@mui/material/styles";
// Acromegaly React contexts
import { useMaterialUIController } from "context";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Toolbar,
  Tooltip,
} from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import TablePaginationActions from "examples/Tables/TablePaginationActions";
import getText from "Translator";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { displayErrorMessage } from "controllers/validation";
import {
  getCapsules,
  updateCapsuleRowNumbers,
  deleteCapsule,
  editCapsules,
} from "controllers/MenuController";
import { displaySuccessMessage } from "controllers/validation";
import { submitCapsule } from "controllers/MenuController";
import { getUsersList } from "controllers/UserController";
import { deleteUser } from "controllers/UserController";
import UserPermission from "./UserPermission";
import { updateActiveState } from "controllers/UserController";
import Register from "./Register";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  td: {
    height: 42,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

let editId;

function Users(props) {
  const [controller] = useMaterialUIController();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [datas, setDatas] = useState([]);
  const [open, setOpen] = useState(false);
  const [openMode, setOpenMode] = useState("");
  const [text, setText] = useState("");
  const [mode, setMode] = useState("new");
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(0);
  const { headline, title } = useParams();

  const navigate = useNavigate();
  const handleChangeActiveStateClick = async (id, isActive) => {
    let data = await updateActiveState(
      { id, isActive: !isActive },
      controller.token
    );
    if (data.success) {
      Swal.fire({
        text: data.message,
        position: "top-end",
        icon: "success",
        showConfirmButton: false,
        timer: 1500,
      });

      setPage(1);
      getData(rowsPerPage, 1, search);
    } else {
      if (data.errorCode === 101) {
        navigate("/authentication/sign-in", { replace: true });
      } else {
        Swal.fire({
          text: data.message,
          icon: "error",
        });
      }
    }
    setLoading(false);
  };
  const handleDeleteClick = (id) => {
    Swal.fire({
      text: getText("deleteconfirm", controller.lang),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: getText("confirmButtonText", controller.lang),
      cancelButtonText: getText("cancel", controller.lang),
    }).then(async (result) => {
      if (result.value) {
        setLoading(true);
        let data = await deleteUser({ id }, controller);
        setLoading(false);
        if (data.success) {
          displaySuccessMessage(
            controller.lang,
            getText("deletesuccessful", controller.lang)
          );

          getData(rowsPerPage, page + 1, search);
        } else {
          if (data.errorCode === 101) {
            navigate("/authentication/sign-in", { replace: true });
          } else {
            displayErrorMessage(controller.lang, data.message, data.code);
          }
        }
        setLoading(false);
      }
    });
  };

  const handleClickOpen = (mode) => {
    setOpenMode(mode);
    setOpen(true);
  };
  const submitCapsuleHandler = async () => {
    let newCapsule = {};
    if (mode === "new") {
      newCapsule = {
        title: title,
        rownumber: count + 1,
        lang: controller.lang,
        text,
      };

      setLoading(true);
      let data = await submitCapsule(
        controller.lang,
        newCapsule,
        controller.token
      );
      if (data.success) {
        Swal.fire({
          text: getText("insertsuccesfully", controller.lang),
          position: "top-end",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
        handleClose();

        getData(rowsPerPage, page + 1, search);
      } else {
        if (data.errorCode === 101) {
          navigate("/authentication/sign-in", { replace: true });
        } else {
          console.log(data);
          displayErrorMessage(controller.lang, data.message, data.code);
        }
      }
    } else {
      newCapsule = {
        id: editId,
        title: title,
        lang: controller.lang,
        text,
      };
      let data = await editCapsules(
        controller.lang,
        newCapsule,
        controller.token
      );
      if (data.success) {
        Swal.fire({
          text: getText("editsuccesfully", controller.lang),
          position: "top-end",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
        handleClose();
        getData(rowsPerPage, page + 1, search);
      } else {
        if (data.errorCode === 101) {
          navigate("/authentication/sign-in", { replace: true });
        } else {
          displayErrorMessage(controller.lang, data.message, data.code);
        }
      }
    }

    setLoading(false);
  };
  const handleClose = () => {
    setOpen(false);
    setMode("new");
    setText("");
  };
  const searchHandler = (serachParam) => {
    console.log("serachParam", serachParam);
    getData(rowsPerPage, page + 1, serachParam);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getData(rowsPerPage, newPage + 1, search);
  };
  const handleDropRows = (droppedItem) => {
    // Ignore drop outside droppable container
    if (!droppedItem.destination) return;
    var updatedList = [...datas];
    // Remove dragged item
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    // Add dropped item
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    // Update State
    updatedList.map((item, index) => {
      item.rownumber = rowsPerPage * page + index + 1;
    });
    updateCapsuleRowNumbers(controller.lang, updatedList, controller.token);
    setDatas(updatedList);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    getData(parseInt(event.target.value, 10), 1, search);
  };
  useEffect(() => {
    if (!controller.authenticated) {
      navigate("/authentication/sign-in", { replace: true });
      return;
    }

    getData(rowsPerPage, 1, "");
  }, []);
  const getData = async (rowsPerPagex, pagex, searchx) => {
    try {
      setLoading(true);
      let newData = {
        rowsPerPage: rowsPerPagex,
        page: pagex,
        search: searchx,
        lang: controller.lang,
      };

      let data = await getUsersList(newData, controller);
      setLoading(false);
      if (data.success) {
        console.log(data.data);
        setDatas(data.data);
        setCount(data.count);
      } else {
        displayErrorMessage(controller.lang, data.message, data.code);
      }
    } catch (err) {
      console.log(err);
      displayErrorMessage(controller.lang);
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar
        title={getText("userlist", controller.lang)}
        searchHandler={searchHandler}
        showserch={true}
      />
      <MDBox pb={3}>
        <Card>
          <MDBox>
            <LoadingOverlay
              active={loading}
              spinner
              text={getText("loading", controller.lang)}
            >
              <Button
                onClick={() => {
                  setOpenMode("newuser");
                  setOpen(true);
                }}
                style={{}}
              >
                ثبت کاربر جدید
              </Button>
              <TableContainer>
                <Table size="larg" sx={{ minWidth: 600 }}>
                  <TableBody>
                    <TableRow style={{ backgroundColor: "#ccc" }}>
                      <TableCell>{getText("name", controller.lang)}</TableCell>
                      <TableCell>
                        {getText("ponenumber", controller.lang)}
                      </TableCell>
                      <TableCell>{getText("email", controller.lang)}</TableCell>
                      <TableCell
                        align="center"
                        style={{ width: 110 }}
                      ></TableCell>
                    </TableRow>

                    {datas.map((row, index) => (
                      <StyledTableRow
                        key={row._id}
                        style={{
                          backgroundColor: index % 2 === 0 ? "#fff" : "#f2f2f2",
                        }}
                      >
                        <TableCell>{row.name}</TableCell>
                        <TableCell>{row.cellphone}</TableCell>
                        <TableCell>{row.email}</TableCell>
                        <TableCell align="center">
                          <div>
                            <Tooltip
                              title={getText("edit", controller.lang)}
                              aria-label="edit"
                              style={{ padding: 3, cursor: "pointer" }}
                            >
                              <AccountTreeIcon
                                style={{
                                  width: 20,
                                  height: 20,
                                  cursor: "pointer",
                                }}
                                color="primary"
                                onClick={async () => {
                                   
                                  editId = row._id;
                                  handleClickOpen("permission");
                                  //   let user={
                                  //     id: row._id,
                                  //     userRole: 'admin'
                                  //   }
                                  // let result = await changeUserRole(user, controller.token);
                                  // console.log(result)
                                }}
                              />
                            </Tooltip>
                            <Tooltip
                              title={"فعال/غیرفعال"}
                              aria-label="active"
                              style={{ padding: 3, cursor: "pointer" }}
                            >
                              <VerifiedUserOutlinedIcon
                                style={{
                                  width: 20,
                                  height: 20,
                                  cursor: "pointer",
                                }}
                                color={row.isActive ? "primary" : "secondry"}
                                onClick={() => {
                                  handleChangeActiveStateClick(
                                    row._id,
                                    row.isActive
                                  );
                                }}
                              />
                            </Tooltip>
                            {/* <Tooltip
                              title={getText("edit", controller.lang)}
                              aria-label="edit"
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <ModeEditOutlineOutlinedIcon
                                style={{ width: 20, height: 20 }}
                                color="secondary"
                                onClick={() => {}}
                              />
                            </Tooltip> */}
                            <Tooltip
                              title={getText("delete", controller.lang)}
                              aria-label="delete"
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <HighlightOffIcon
                                style={{
                                  width: 20,
                                  height: 20,
                                  cursor: "pointer",
                                }}
                                color="primary"
                                onClick={() => {
                                  handleDeleteClick(row._id);
                                }}
                              />
                            </Tooltip>
                          </div>
                        </TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[
                          5,
                          10,
                          25,
                          { label: "All", value: count },
                        ]}
                        colSpan={5}
                        count={count}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: {
                            "aria-label": "Rows per page",
                          },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </LoadingOverlay>
          </MDBox>
        </Card>
      </MDBox>
      {/* <Dialog
        open={open}
         aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {mode === "new"
            ? getText("addnewclinic", controller.lang)
            : getText("editclinic", controller.lang)}

          <HighlightOffIcon
            style={{
              width: 20,
              height: 20,
              float: controller.direction == "rtl" ? "left" : "right",
            }}
            color="primary"
            onClick={() => {
              handleClose();
            }}
          />
        </DialogTitle>
        <DialogContent>
          {getText("text", controller.lang)}
          <TextField
            autoFocus
            id="text"
            fullWidth
            variant="outlined"
            style={{ minWidth: 450 }}
            value={text}
            onChange={(event) => {
              setText(event.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="secondary"
            style={{ float: "right", minWidth: 120 }}
          >
            {getText("cancel", controller.lang)}
          </Button>
          <Button active onClick={submitCapsuleHandler} color="primary">
            {mode === "new"
              ? getText("submit", controller.lang)
              : getText("edit", controller.lang)}
          </Button>
        </DialogActions>
      </Dialog> */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        {/* <AppBar className="appBar">
          <Toolbar>
            <IconButton
              className="closeIcon"
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            {getText("userpermission", controller.lang)}
          </Toolbar>
        </AppBar> */}

        <DialogContent>
          {openMode == "permission" && (
            <UserPermission
              userId={editId}
              history={props.history}
              handleClose={handleClose}
            />
          )}
          {openMode == "newuser" && (
            <Register
              closeSheet={handleClose}
              getData={getData}
              rowsPerPage={rowsPerPage}
            />
          )}
        </DialogContent>
      </Dialog>
    </DashboardLayout>
  );
}

export default Users;
